/* =========================================================
   GRAVURE: ZACHTE TEKENLIMIET
   - Elk graveerveld heeft een normale limiet (data-gravure-limit).
   - Tot EXTRA tekens meer mag: veld krijgt een rode rand, een rode teller
     en een melding dat de regel iets smaller (in elkaar gedrukt) gegraveerd wordt.
     Alles gaat gewoon mee in de bestelling.
   - Meer dan limiet + EXTRA kan niet worden getypt. Komt het er toch boven
     (bv. na het kiezen van een kleinere maat), dan blokkeert de winkelwagenknop
     tot de tekst korter is.
   - In de preview wordt een te lange regel horizontaal in elkaar gedrukt.
   - Bij icoontjes gaat er een regel "Gegraveerde icoontjes" mee (teken + naam).
   Meldingen: locales (product.gravure_*), dus vertaalbaar.
   Opmaak: assets/id4all-stijl.css (blok GRAVURE).
   ========================================================= */
(function () {
  'use strict';

  var EXTRA = 2; /* aantal tekens dat boven de limiet mag (smaller graveren) */

  var IDS = [
    'silicone-text-1', 'silicone-text-2',
    'fabric-text-icons-1-no-qr',
    'fabric-text-line-1-no-qr', 'fabric-text-line-2-no-qr',
    'fabric-text-line-3-no-qr', 'fabric-text-line-4-no-qr',
    'qr-text-input', 'qr-text-input-2'
  ];

  var T = window.translations || {};
  function tekst(key, n, fallback) {
    var v = T[key];
    if (!v || /translation missing/i.test(v)) v = fallback;
    return String(v).replace('[n]', n);
  }

  function inputs() {
    return IDS.map(function (id) { return document.getElementById(id); }).filter(Boolean);
  }
  function limitOf(el) { return parseInt(el.getAttribute('data-gravure-limit'), 10) || 0; }
  function zichtbaar(el) { return el.offsetParent !== null; }

  /* ---------- Limiet zetten (ook vanuit iska.js bij maatwissel) ---------- */
  function setLimit(el, limit) {
    limit = parseInt(limit, 10);
    if (!el || !limit) return;
    el.setAttribute('data-gravure-limit', limit);
    el.setAttribute('maxlength', limit + EXTRA);
    check(el);
  }

  /* ---------- Teller + melding onder het veld ---------- */
  function ui(el) {
    if (el._gravureUi && el._gravureUi.isConnected) return el._gravureUi;
    var box = document.createElement('div');
    box.className = 'gravure-status';
    box.id = el.id + '-gravure';
    box.innerHTML = '<span class="gravure-status__melding" aria-live="polite"></span>' +
                    '<span class="gravure-status__teller"></span>';
    el.insertAdjacentElement('afterend', box);
    /* Teller strak onder het veld: de ondermarge van het veld schuift naar onder de teller */
    var mb = parseFloat(getComputedStyle(el).marginBottom) || 0;
    if (mb > 0) {
      box.style.marginTop = 'calc(' + (-mb) + 'px + 0.2rem)';
      box.style.marginBottom = mb + 'px';
    }
    var desc = el.getAttribute('aria-describedby');
    el.setAttribute('aria-describedby', (desc ? desc + ' ' : '') + box.id);
    el._gravureUi = box;
    return box;
  }

  function check(el) {
    var limit = limitOf(el);
    if (!limit) return;
    var len = el.value.length;
    var over = len - limit;
    var box = ui(el);
    var teller = box.querySelector('.gravure-status__teller');
    var melding = box.querySelector('.gravure-status__melding');

    var smaller = over > 0 && over <= EXTRA;
    var blok = over > EXTRA;

    el.classList.toggle('gravure--te-lang', over > 0);
    el.classList.toggle('gravure--blok', blok);
    box.classList.toggle('gravure-status--leeg', len === 0);
    box.classList.toggle('gravure-status--te-lang', over > 0);
    el.setAttribute('aria-invalid', blok ? 'true' : 'false');

    teller.textContent = len + '/' + limit;

    if (blok) {
      melding.textContent = tekst('gravureTeVeel', over - EXTRA,
        'Te lang: haal [n] teken(s) weg.');
    } else if (smaller) {
      melding.textContent = (over === 1)
        ? tekst('gravureOverEen', 1, '1 teken te veel: deze regel graveren we iets smaller.')
        : tekst('gravureOver', over, '[n] tekens te veel: deze regel graveren we iets smaller.');
      if (over === EXTRA) melding.textContent += ' ' + tekst('gravureVol', 0, 'Meer past er niet op.');
    } else {
      melding.textContent = '';
    }

    planPreview();
    icoontjes(el.form);
  }

  function checkAll() { inputs().forEach(check); }

  /* ---------- Regel "Gegraveerde icoontjes" in de bestelling ----------
     In de checkout (van Shopify) staan icoontjes als losse tekens (¬, ¼ ...).
     Deze regel zegt welk teken welk icoontje is: "¬ palmboom, ¼ SOS-kruis".
     (Geen · als scheidingsteken: dat is in het lettertype het autisme-icoontje.)
     Elk icoontje één keer, in volgorde van kiezen; leeg = regel gaat niet mee.
     Namen: data-naam op de knoppen (snippets/id4all-iconen.liquid). */
  function iconenKaart() {
    var kaart = {};
    document.querySelectorAll('#fun-icons-keyboard button[data-naam], #medical-icons-keyboard button[data-naam]').forEach(function (b) {
      var teken = (b.textContent || '').trim();
      if (teken && !kaart[teken]) kaart[teken] = b.getAttribute('data-naam');
    });
    return kaart;
  }
  function icoontjes(form) {
    if (!form) return;
    var veld = form.querySelector('input[data-gravure-iconen]');
    if (!veld) {
      veld = document.createElement('input');
      veld.type = 'hidden';
      veld.name = 'properties[' + tekst('gravureIconenLabel', 0, 'Gegraveerde icoontjes') + ']';
      veld.setAttribute('data-gravure-iconen', '');
      form.appendChild(veld);
    }
    var kaart = iconenKaart();
    var gezien = [];
    inputs().forEach(function (el) {
      if (el.form !== form || !zichtbaar(el)) return;
      Array.from(el.value).forEach(function (ch) {
        if (kaart[ch] && gezien.indexOf(ch) === -1) gezien.push(ch);
      });
    });
    veld.value = gezien.map(function (ch) { return ch + ' ' + kaart[ch]; }).join(', ');
    veld.disabled = gezien.length === 0;
  }


  /* ---------- Preview: te lange regel horizontaal in elkaar drukken ---------- */
  var gepland = false;
  function planPreview() {
    if (gepland) return;
    gepland = true;
    requestAnimationFrame(function () { gepland = false; preview(); });
  }
  function preview() {
    var teLang = inputs().filter(function (el) {
      var limit = limitOf(el);
      return limit && el.value.length > limit;
    });
    document.querySelectorAll('.live-preview-overlay [class*="preview-text"]').forEach(function (span) {
      var txt = span.textContent;
      var bron = null;
      for (var i = 0; i < teLang.length; i++) {
        if (teLang[i].value === txt || teLang[i].value.trim() === txt.trim()) { bron = teLang[i]; break; }
      }
      if (bron) {
        var factor = Math.max(0.5, limitOf(bron) / bron.value.length);
        span.style.setProperty('scale', factor.toFixed(3) + ' 1');
        if (getComputedStyle(span).display === 'inline') span.style.display = 'inline-block';
      } else if (span.style.getPropertyValue('scale')) {
        span.style.removeProperty('scale');
      }
    });
  }

  /* ---------- Winkelwagen blokkeren als het echt te lang is ---------- */
  function blokkeer(e, el) {
    var form = el.closest('form') || (el.form) ||
      (el.closest('product-form') && el.closest('product-form').querySelector('form'));
    if (form) icoontjes(form);
    var fout = inputs().filter(function (i) {
      return (!form || i.form === form) && zichtbaar(i) && limitOf(i) && i.value.length > limitOf(i) + EXTRA;
    });
    if (!fout.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    check(fout[0]);
    fout[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
    try { fout[0].focus({ preventScroll: true }); } catch (err) {}
  }
  document.addEventListener('click', function (e) {
    var knop = e.target.closest('.product-form__submit');
    if (knop) blokkeer(e, knop);
  }, true);
  document.addEventListener('submit', function (e) {
    if (e.target.matches('form[data-type="add-to-cart-form"]')) blokkeer(e, e.target);
  }, true);

  /* ---------- Starten ---------- */
  function init() {
    inputs().forEach(function (el) {
      if (limitOf(el)) return;
      /* Startlimiet = maxlength uit de Liquid-instelling; siliconen zonder maat: 16 */
      setLimit(el, parseInt(el.getAttribute('maxlength'), 10) || 16);
    });
  }

  document.addEventListener('input', function (e) {
    if (e.target && IDS.indexOf(e.target.id) !== -1) check(e.target);
  });
  /* Icoontjes worden ingevoegd zonder input-event */
  document.addEventListener('click', function (e) {
    if (e.target.closest('#fun-icons-keyboard, #medical-icons-keyboard, #selectors-btn-cont')) {
      setTimeout(checkAll, 0);
    }
  });
  /* Preview opnieuw na elke update van de overlay */
  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      var t = list[i].target;
      var node = t.nodeType === 1 ? t : t.parentElement;
      if (node && node.closest && node.closest('.live-preview-overlay, .product__media-list, .product__media-wrapper')) {
        planPreview();
        return;
      }
    }
  }).observe(document.body, { childList: true, characterData: true, subtree: true });

  window.gravureLimiet = { set: setLimit, check: check, checkAll: checkAll, EXTRA: EXTRA };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
